import {EvLabel} from '../../components/labels/ev-label';

interface Props {
  isDeleted: boolean;
  isLocked: boolean;
}

export function ArticleLabel(props: Props) {
  if (props.isDeleted) {
    return <EvLabel labeltype="danger">Gelöscht</EvLabel>;
  } else if (props.isLocked) {
    return <EvLabel labeltype="warning">Gesperrt</EvLabel>;
  } else {
    return <EvLabel labeltype="success">Aktiv</EvLabel>;
  }
}
